import { render, staticRenderFns } from "./QuiltyInsightsGeneralPane.vue?vue&type=template&id=2df98eae&"
import script from "./QuiltyInsightsGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./QuiltyInsightsGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports